import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types/lib/DateFromISOString'

import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

// import { Signer } from '../../../domain/grants'

export const signingData = {
  sentForSigningAt: t.union([tv.dateTimeFromString, t.undefined])
  // signers: t.array(Signer, 'Signer[]')
}

export const sentData = {
  // can be local date (paper app) or datetime
  // decode date and later map to date time
  sentAt: DateFromISOString
}

export const reviewData = {
  reviewStartedAt: tv.dateTimeFromString
}
